import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { useNavigate } from 'react-router-dom';

import { v2Colors } from '../../design/theme';

export default function CartPageHeader({ onClearAll, clearDisabled }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
      <IconButton
        aria-label="Go back"
        onClick={() => navigate(-1)}
        sx={{
          width: 40,
          height: 40,
          bgcolor: v2Colors.white,
          border: `1px solid ${v2Colors.primary}`,
          color: v2Colors.primary,
          '&:hover': { bgcolor: v2Colors.selectedFill },
        }}
      >
        <ArrowBackRounded fontSize="small" />
      </IconButton>
      <Typography
        component="h1"
        sx={{
          flex: 1,
          fontWeight: 700,
          fontSize: { xs: '1.5rem', sm: '1.65rem' },
          color: v2Colors.heading,
          lineHeight: 1.15,
        }}
      >
        Your bag
      </Typography>
      {onClearAll ? (
        <Box
          component="button"
          type="button"
          disabled={clearDisabled}
          onClick={onClearAll}
          sx={{
            border: 'none',
            bgcolor: 'transparent',
            color: v2Colors.primary,
            fontWeight: 600,
            fontSize: '0.875rem',
            fontFamily: 'inherit',
            cursor: clearDisabled ? 'not-allowed' : 'pointer',
            opacity: clearDisabled ? 0.5 : 1,
            py: 0.5,
            px: 0.25,
            '&:hover': clearDisabled ? {} : { opacity: 0.85 },
          }}
        >
          Clear all
        </Box>
      ) : null}
    </Box>
  );
}
